/**
 * Actions
 */
export default {
    performLogin({ commit }, value) {
        commit('setUser', value);
    },
    cleanAuthData({ commit }) {
        commit('cleanAuthData');
    },
    saveSessionMessage({ commit }, values) {
        commit('setSessionMessage', { message: values.message, type: values.messageType });
    },
    cleanSessionMessage({ commit }) {
        commit('cleanSessionMessage');
    },
    saveOnComboChest({ commit }, values) {
        commit('saveOnComboChest', { key: values.key, value: values.value })
    },
    saveOnDataChest({ commit }, values) {
        commit('saveOnDataChest', { key: values.key, value: values.value })
    },
    cleanDataChest({ commit }) {
        commit('cleanDataChest')
    },
    cleanComboChest({ commit }) {
        commit('cleanComboChest')
    },
    removeFromDataChest({ commit }, values) {
        commit('removeFromDataChest', { key: values })
    },
    removeFromComboChest({ commit }, values) {
        commit('removeFromComboChest', { key: values })
    },
    saveCookiesAccepted({ commit }, values) {
        commit('saveCookieAccepted', { aceppted: values })
    },
    saveToken({ commit }, value) {
        commit('saveToken', { token: value })
    },
    saveRegeneratorCalled({ commit }, value) {
        commit('saveRegeneratorCalled', value)
    },
    saveRequestedRoute({ commit }, value) {
        commit('saveRequestedRoute', value)
    },
    saveCalledRequests({ commit }, value) {
        commit('saveCalledRequests', value)
    },
    saveIsLogging({ commit }, value) {
        commit('saveIsLogging', value);
    },
    saveContext({ commit }, value) {
        commit('saveContext', value);
    },
    savePurchaseItems({ commit }, value) {
        commit('SAVE_PURCHASE_ITEMS', value);
    },
};